import React from 'react';
import { store } from '@/app/store';

export interface RoleInfo {
  admin:			boolean;
  role:				string;
  privilages:        string[];
}

export const RoleContext = React.createContext({
  admin:			false,
  role:				"",
  privilages: []
} as RoleInfo);

export interface ApiResult {
  response:			Response;
  result:			any;
}

export const apiOperation = async (method: string, url: string, payload?: any, raw?: boolean): Promise<ApiResult> => {
  let opts: any = {};
  if (method != "")
    opts.method = method;
  if (payload)
    opts.body = JSON.stringify(payload);
  
  try {
    console.error("apiOperation|url=" + url + "|method=" + method + "|Calling fetch!");
    
    const response = await fetch(url, opts);
    
    if (!response.ok) {
		console.error("apiOperation|url=" + url + "|method=" + method + "|Response was not OK!", response);
		// 2FA endpoints return 401 for wrong-code / expired-ticket / lockout —
		// NOT for an expired session. The callers parse those bodies (e.g.
		// locked_until) and surface inline errors. We must not bump status
		// to 0 here or the user gets kicked to login mid-verify (infinite
		// loop after a wrong code).
		const isCodeVerifyUrl =
			url.indexOf("/2fa.json") !== -1 ||
			url.indexOf("/login/2fa.json") !== -1 ||
			url.indexOf("/email.json") !== -1 ||
			url.indexOf("/change_password.json") !== -1;
		if (response.status == 401) {
		  if (!isCodeVerifyUrl) store.dispatchStatus(0);
		} else
		if (	method != "GET" ||
				url.indexOf("/logins.json") == -1
		   ) {
		  const txt = await response.text();
		  try {
		    const parsed = JSON.parse(txt);
		    if (parsed.errors && parsed.errors.length && parsed.errors[0].error) {
		      store.dispatchError(parsed.errors[0].error);
		    } else {
		      store.dispatchError(txt);
		    }
		  } catch(e) {
		    store.dispatchError(txt ? txt : response.statusText);
		  }
		}
		return {
		  response:			response,
		  result:			null,
		};
	}
    
	if (url.indexOf("/login/2fa.json") === -1 &&
	    url.indexOf("/password_reset.json") === -1)
	  store.dispatchStatus(1);

	if (raw)
	  return {
		response:		response,
		result:			response,
	  };
	
	const res = await response.json();
	if (	typeof res == "object" &&
			res.errors &&
			Array.isArray(res.errors) &&
			res.errors.length
	   ) {
	  if (res.errors[0].code != 0) {
	    store.dispatchError(res.errors[0].code + ': ' + res.errors[0].error);
	  } else {
	    store.dispatchSuccess(res.errors[0].code + ': ' + res.errors[0].error);
	  }
	}
	
	return {
	  response:			response,
	  result:			res,
	};
  } catch(e) {
	console.error("apiOperation|url=" + url + "|method=" + method + "|Failed to fetch:", e);
	throw(e);
  }
}

export const sleep = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export function padZeros(val: any, num?: number) {
	let str = val.toString();
	
	if (num === undefined)
	  num = 2;
	
	while (str.length < num)
	  str = "0" + str;
	
	return str;
}

export function valToString(val: unknown) {
	return	val
            ?	val as string
			:	"";
}

export function numericSort(a: string, b: string) {
  const va = parseFloat(a)
  const vb = parseFloat(b)
  
  if (va == vb)
    return 0;
  
  return (va > vb) ? 1 : -1;
}



